export default function getScreenWidth(width) {
    return width < 1023;
}
